module.exports = __webpack_public_path__ + "img/morningRef1.e922c7ca.jpg";